import React, { useState, useRef, useEffect } from "react";
import './styles/voiceButton.css'
import ShowLoading from './loading';

const VoiceSearchButton = ({ onResult }) => {
  const [recording, setRecording] = useState(false);
  const [audioBlob, setAudioBlob] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const timerRef = useRef(null);

  const startRecording = async () => {
    if (recording) return;
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new window.MediaRecorder(stream);
      audioChunksRef.current = [];
      mediaRecorderRef.current.ondataavailable = (event) => {
        if (event.data.size > 0) {
          audioChunksRef.current.push(event.data);
        }
      };
      mediaRecorderRef.current.onstop = () => {
        const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
        setAudioBlob(audioBlob);
        // playAudio(audioBlob);
        sendAudioToBackend(audioBlob);
      };
      mediaRecorderRef.current.start();
      setRecording(true);
      
      // Set timer to stop recording after 5 seconds
      timerRef.current = setTimeout(() => {
        stopRecording();
      }, 5000);
    } catch (err) {
      alert('Microphone access denied or not available.');
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current && recording) {
      mediaRecorderRef.current.stop();
      setRecording(false);
      // Clear the timer if it exists
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    }
  };

  // Cleanup timer on component unmount
  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  const toggleRecording = () => {
    if (recording) {
      stopRecording();
    } else {
      startRecording();
    }
  };

  const playAudio = (audio) => {
    if (audio) {
      const url = URL.createObjectURL(audio);
      const audioObj = new Audio(url);
      audioObj.currentTime = 0;
      audioObj.play();
      // Optionally, clean up the object URL after playback
      //audioObj.onended = () => URL.revokeObjectURL(url);
    }
  }

  // Send audioBlob to Flask backend
  const sendAudioToBackend = async (blob) => {
    if (!blob) return;
    setIsLoading(true);
    const formData = new FormData();
    formData.append('audio_data', blob, 'recording.webm');
    try {
      const response = await fetch("https://yorubadictionary.yale.edu/api/transcribe", {
        method: 'POST', 
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Success!", data.transcription);

      let betterResult = data.transcription.toLowerCase()
        .replace(/sh/gi, 'ṣ')
        .replace(/ch/gi, 'ṣ')
        .replace(/ee/g, "i")
        .replace(/([bcdfghjklmnpqrstvwxyz])\1/gi, "$1")
        .replace(/[.,!?;:'"-]/g, "")
        .replace(/c/g, 'k')
        .replace(/qu/g, 'kiw')
        .replace(/q/g, 'ki');

      if (betterResult.endsWith("y")){
        betterResult = betterResult.slice(0, -1) + "i";
      }

      console.log("Better", betterResult);

      onResult(betterResult);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && <ShowLoading />}
      <button
        className="voice-search-btn"
        onClick={toggleRecording}
        disabled={isLoading}
      >
        <svg className="Audio-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 15c1.66 0 3-1.34 3-3V6c0-1.66-1.34-3-3-3s-3 1.34-3 3v6c0 1.66 1.34 3 3 3zm5-3c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-2.08c3.39-.49 6-3.39 6-6.92h-2z"/>
        </svg>
        {recording ? 'Recording...' : 'Search with Voice'}
      </button>
    </>
  );
};

export default VoiceSearchButton;